import type from "./type";

export default type("text/plain", function(xhr) {
  return xhr.responseText;
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-request/src/text.js
// module id = 420
// module chunks = 0